import type { AnyRouter } from "@tanstack/react-router";
import { useVisitedRoutesStore } from "@stores/useVisitedRoutesStore";

export function trackVisitedRoutes(router: AnyRouter) {
    const record = () => {
        const loc = router.state.location;
        useVisitedRoutesStore.getState().push({
        href: loc.href,
        pathname: loc.pathname,
        });
    };

    record(); // initial route

    return router.subscribe("onResolved", () => {
        record();
    });
}
